import { DataModel, DataModelBuilder, isSameData,
  isSameList, SerializationContext, SerializedData } from '../dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { ProfileElementGroup } from './profile-element-group.js';

export class ProfileElementGroupList extends DataModel {
  static readonly TYPE_ID: string = '3ba45b3960464f9ab380f3b480b4c5f6';

  constructor(
    public readonly groups: ProfileElementGroup[],
  ) {
    super();
  }

  get $typeId(): string {
    return ProfileElementGroupList.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ProfileElementGroupList {
    return new ProfileElementGroupList(
        MapUtils.getList<ProfileElementGroup>(map, 'groups', (value) =>
          context.fromData<ProfileElementGroup>(value as SerializedData)),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'groups': this.groups.map((t) => context.toData(t)),
    };
  }

  clone(): this {
    return new ProfileElementGroupList(
        this.groups.map((e) => e.clone()),
    ) as this;
  }

  isSame(other: ProfileElementGroupList): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.groups, this.groups, isSameData);
  }
}

export class ProfileElementGroupListBuilder extends DataModelBuilder<ProfileElementGroupList> {
  build(context: SerializationContext, map: SerializedData): ProfileElementGroupList {
    return ProfileElementGroupList.fromMap(context, map);
  }
}
